import { useMsal } from "@azure/msal-react";
import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./LaunchDataDisplay.css";
import SubmissionPopup from "./SubmissionPopup";
const LaunchDataDisplay = ({
 setIsMailGenerated,
 setNavigatedToForm,
 modalResponse,
 isLoading,

 setOpen,
 open,
 handleReset,
 mailerParent,
 mailerChild,
 categoryName,
 programName,
}) => {
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [userID, setUserID] = useState(null);
 const [userData, setUserData] = React.useState("");
 //  const [isSubmitted, setIsSubmitted] = React.useState(null);
 const isSubmitted = useSelector((state) => state.model.isSubmitted);
 const dispatch = useDispatch();
 useEffect(() => {
  if (activeAccount) {
   setUserID(activeAccount.idTokenClaims.enterpriseID);
  }
 }, [activeAccount]);

 return (
  <>
   <div className="result-container">
    <div className="result-wrap">
     <div className="result-content">
      {isLoading && (
       <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
         height: "100%",
         justifyContent: "center",
        }}
       >
        <CircularProgress />
        <Typography variant="h6" marginTop={2}>
         Generating...
        </Typography>
       </Box>
      )}
      {!isLoading && modalResponse != "" && (
       <Stack spacing={2} sx={{ height: "500px", padding: "0px", background: "white" }}>
        <style>
         {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
        </style>

        <div style={{ overflowY: "scroll", height: "500px", border: "0px !important" }}>
         <Markdown>{modalResponse}</Markdown>
        </div>
       </Stack>
      )}
     </div>
     <div className="result-btn-container">
      <div className="result-left">
       {!isLoading && (
        <Button
         variant="outlined"
         sx={{ marginRight: "10px" }}
         disabled={isSubmitted ? true : false}
         onClick={() => {
          setOpen(true);
         }}
        >
         Submit For Approval
        </Button>
       )}
      </div>
      <div className="result-right">
       <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
       <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
      </div>
     </div>
    </div>
    <div className="return-wrap">
     <p
      onClick={() => {
       setIsMailGenerated(null);
       setNavigatedToForm(true);
      }}
     >
      {"<"} Back
     </p>
    </div>
    <SubmissionPopup
     open={open}
     setOpen={setOpen}
     userID={userID}
     mailerParent={mailerParent}
     mailerChild={mailerChild}
     programName={programName}
     modalResponse={modalResponse}
     categoryName={categoryName}
     handleReset={handleReset}
    />
   </div>
  </>
 );
};

export default LaunchDataDisplay;
